import React from 'react';
import PropTypes from 'prop-types';
import { THEMES, cycleTheme, setTheme } from './theme';

const LABEL = {
  [THEMES.LIGHT]: 'Light',
  [THEMES.DARK]: 'Dark',
  [THEMES.SYSTEM]: 'System'
};

/**
 * Cycles light → dark → system.
 *
 * Controlled from `NextRoot` rather than owning the state itself, because the
 * resolved theme has to end up as an attribute on that component's element —
 * writing it to `<html>` would leak the new design system into the old admin.
 */
export default function ThemeToggle({ preference, onChange }) {
  const next = () => {
    const value = cycleTheme(preference);
    setTheme(value);
    onChange(value);
  };

  return (
    <button
      type="button"
      className="next-theme-toggle"
      onClick={next}
      title="Switch theme"
      aria-label={`Theme: ${LABEL[preference]}. Click to change.`}
    >
      {LABEL[preference]}
    </button>
  );
}

ThemeToggle.propTypes = {
  preference: PropTypes.oneOf(Object.values(THEMES)).isRequired,
  onChange: PropTypes.func.isRequired
};
